import React from "react";

/** Tracks the input properties, logs any (visible) changes
 * @param {Record<string, any>} current
 */
export function useChangeLogger(name, current = {}) {
  const prev = React.useRef({});

  React.useEffect(() => {
    if (!!prev.current && Object.values(prev.current).length > 0) {
      const changes = {};

      Object.keys(current).forEach((key) => {
        if (prev.current[key] !== current[key]) {
          changes[key] = { from: prev.current[key], to: current[key] };
        }
      });

      if (Object.keys(changes).length > 0) {
        console.debug(`🔭 ${name} changed:`, changes);
      }
    }

    prev.current = current;
  }, [name, current]);
}
